"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTodayDateStr = exports.convertToDate = exports.convertToYMD = void 0;
const moment_1 = __importDefault(require("moment"));
// from Date to yyyy-mm-dd
const convertToYMD = date => {
    const newDate = moment_1.default(date).format('YYYY-MM-DD');
    return newDate;
};
exports.convertToYMD = convertToYMD;
// from yyyy-mm-dd to Date
const convertToDate = date => {
    const convertedDate = moment_1.default(date).format('YYYY-MM-DD');
    const newDate = moment_1.default(convertedDate, moment_1.default.defaultFormat).toDate();
    return newDate;
};
exports.convertToDate = convertToDate;
const getTodayDateStr = () => {
    const today = moment_1.default.utc();
    return today.format('YYYY-MM-DD');
};
exports.getTodayDateStr = getTodayDateStr;
//# sourceMappingURL=dateConversionRules.js.map